// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionN_comp__Spx5c"};